export default __webpack_public_path__ + "static/kirin-ed845c166ec08927b553e0c1530abb01.jpg";